import styled from 'styled-components';
import { StyledFitness } from './styled';
export const AppPitchCard = styled.div`
  position:relative; width:120px; height:116px; cursor:pointer; opacity:${({$muted})=>$muted ? 0.72 : 1};
  .kit { height:88px; display:flex; align-items:flex-end; justify-content:center; }
  .kit img { width:74px; height:88px; max-height:88px; object-fit:contain; margin:0; }
  .ratings { position:absolute; left:3px; top:18px; background:#071d15; border-radius:7px; overflow:hidden; width:28px; font:600 13px 'Archivo Condensed',Archivo,sans-serif; }
  .ratings span { display:flex; height:25px; align-items:center; justify-content:center; }
  .ratings span + span { border-top:1px solid #496252; }
  .identity { position:relative; margin-top:-16px; z-index:1; background:#fff; color:#10231b; border:3px solid ${props=>props.$highlight?'#78f3a1':'#b2d9b9'}; border-radius:10px; padding:4px; box-shadow:0 3px 8px #133f2833; }
  .identity-line { display:flex; align-items:center; min-height:22px; gap:4px; font:600 14px 'Archivo Condensed',Archivo,sans-serif; }
  .slot {
    flex-shrink:0; padding:2px 4px; border-radius:3px; background:#f1f5f2;
    font-weight:700; letter-spacing:.02em; font-variant-numeric:tabular-nums;
    line-height:1.1;
  }
  .identity button, .player-name { font:inherit; color:inherit; background:none; border:0; padding:0; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; min-width:0; cursor:pointer; }
  ${StyledFitness} { width:100%; height:6px; margin-top:4px; border-radius:8px; background:#e3eee5; overflow:hidden; }
  ${StyledFitness}:before { height:6px; border-radius:8px; }
  /* Tablet / mid — readable, but not so wide that four-across plates collide. */
  @media(max-width:1199px) {
    width:clamp(78px,12vw,96px); height:96px;
    .kit {height:70px;} .kit img {width:58px;height:70px;max-height:70px;}
    .ratings {display:block;left:2px;top:12px;width:22px;border-radius:6px;font-size:10px;}
    .ratings span {height:19px;}
    .identity {border-width:2px;border-radius:8px;padding:3px;margin-top:-14px;}
    .identity-line {font-size:11px;gap:3px;min-height:18px;}
    .slot {padding:1px 2px;}
    ${StyledFitness} {height:4px;margin-top:3px;}
    ${StyledFitness}:before {height:4px;}
  }
  @media(max-width:767px) {
    width:clamp(64px,17vw,78px); height:82px;
    .kit {height:58px;} .kit img {width:48px;height:58px;max-height:58px;}
    .ratings {top:10px;width:18px;font-size:9px;}
    .ratings span {height:16px;}
    .identity {padding:2px;margin-top:-12px;border-radius:7px;}
    .identity-line {font-size:10px;gap:2px;min-height:16px;}
    ${StyledFitness} {height:4px;margin-top:2px;}
    ${StyledFitness}:before {height:4px;}
  }
`;
